import script from "./gender.vue?vue&type=script&setup=true&lang=ts"
export * from "./gender.vue?vue&type=script&setup=true&lang=ts"

import "./gender.vue?vue&type=style&index=0&id=2308c7fe&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2308c7fe"]])

export default __exports__